export const NOT_AVAILABLE = "N/A";

export const DID_NOT_CALL = "NOT_CALLED";
